export const DEFAULT_LANG = 'en';

export const TRANSLATIONS = {
    nl: {
        "Subscribe": "Abonneren",
        "Account": "Account",
        "Everything you need to run your optical practice, smarter and faster.": "Alles wat u nodig heeft om uw optiekpraktijk slimmer en sneller te runnen.",
        "Get Demo": "Vraag Demo",
        "About the app": "Over de app",
        "Features": "Functies",
        "All. de la Recherche 12": "All. de la Recherche 12",
        "1070 Brussels": "1070 Brussel",
        "Privacy Policy": "Privacybeleid",
        "Terms & Conditions": "Algemene Voorwaarden",
        "By": "Door",
        "Written by": "Geschreven door",
        "Read more": "Lees meer",
        "Website": "Website",
        "Twitter": "Twitter",
        "Facebook": "Facebook",
        "A collection of": "Een verzameling van",
        "posts": "berichten",
        "% post": "% bericht",
        "% posts": "% berichten"
    },
    fr: {
        "Subscribe": "S'abonner",
        "Account": "Compte",
        "Everything you need to run your optical practice, smarter and faster.": "Tout ce dont vous avez besoin pour gérer votre cabinet d'optique, plus intelligemment et plus rapidement.",
        "Get Demo": "Obtenir une démo",
        "About the app": "À propos de l'application",
        "Features": "Fonctionnalités",
        "All. de la Recherche 12": "All. de la Recherche 12",
        "1070 Brussels": "1070 Bruxelles",
        "Privacy Policy": "Politique de confidentialité",
        "Terms & Conditions": "Termes et conditions",
        "By": "Par",
        "Written by": "Écrit par",
        "Read more": "Lire la suite",
        "Website": "Site web",
        "Twitter": "Twitter",
        "Facebook": "Facebook",
        "A collection of": "Une collection de",
        "posts": "articles",
        "% post": "% article",
        "% posts": "% articles"
    },
    de: {
        "Subscribe": "Abonnieren",
        "Account": "Konto",
        "Everything you need to run your optical practice, smarter and faster.": "Alles, was Sie brauchen, um Ihre Augenarztpraxis intelligenter und schneller zu führen.",
        "Get Demo": "Demo anfordern",
        "About the app": "Über die App",
        "Features": "Funktionen",
        "All. de la Recherche 12": "All. de la Recherche 12",
        "1070 Brussels": "1070 Brüssel",
        "Privacy Policy": "Datenschutzrichtlinie",
        "Terms & Conditions": "Allgemeine Geschäftsbedingungen",
        "By": "Von",
        "Written by": "Geschrieben von",
        "Read more": "Weiterlesen",
        "Website": "Webseite",
        "Twitter": "Twitter",
        "Facebook": "Facebook",
        "A collection of": "Eine Sammlung von",
        "posts": "Beiträgen",
        "% post": "% Beitrag",
        "% posts": "% Beiträge"
    },
    it: {
        "Subscribe": "Iscriviti",
        "Account": "Account",
        "Everything you need to run your optical practice, smarter and faster.": "Tutto ciò di cui hai bisogno per gestire il tuo studio ottico in modo più intelligente e veloce.",
        "Get Demo": "Richiedi Demo",
        "About the app": "Informazioni sull'app",
        "Features": "Funzionalità",
        "All. de la Recherche 12": "All. de la Recherche 12",
        "1070 Brussels": "1070 Bruxelles",
        "Privacy Policy": "Informativa sulla privacy",
        "Terms & Conditions": "Termini e condizioni",
        "By": "Di",
        "Written by": "Scritto da",
        "Read more": "Leggi di più",
        "Website": "Sito web",
        "Twitter": "Twitter",
        "Facebook": "Facebook",
        "A collection of": "Una collezione di",
        "posts": "post",
        "% post": "% post",
        "% posts": "% post"
    }
};
